namespace GeniuzPOS.Purchase {
    export interface ReportPendingPODtRow {
        Id?: number;
        SysDocNo?: string;
        UseFg?: number;
        LineItemNo?: number;
        SkuCode?: string;
        SkuDesc?: string;
        Qty?: number;
        UnitQty?: number;
        PurUnit?: string;
        StkQty?: number;
        QtyUse?: number;
        StkUnit?: string;
        LessQty?: number;
        UnitCost?: number;
        LessCost?: number;
        Remark?: string;
        PrRefDocNo?: string;
    }

    export namespace ReportPendingPODtRow {
        export const idProperty = 'Id';
        export const nameProperty = 'SysDocNo';
        export const localTextPrefix = 'Purchase.ReportPendingPODt';
        export const lookupKey = 'Purchase.ReportPendingPODt';

        export function getLookup(): Q.Lookup<ReportPendingPODtRow> {
            return Q.getLookup<ReportPendingPODtRow>('Purchase.ReportPendingPODt');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            SysDocNo = "SysDocNo",
            UseFg = "UseFg",
            LineItemNo = "LineItemNo",
            SkuCode = "SkuCode",
            SkuDesc = "SkuDesc",
            Qty = "Qty",
            UnitQty = "UnitQty",
            PurUnit = "PurUnit",
            StkQty = "StkQty",
            QtyUse = "QtyUse",
            StkUnit = "StkUnit",
            LessQty = "LessQty",
            UnitCost = "UnitCost",
            LessCost = "LessCost",
            Remark = "Remark",
            PrRefDocNo = "PrRefDocNo"
        }
    }
}
